import React from "react";
import Logo from "../../images/knust-logo.png";
import { FaTwitter, FaFacebook, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

export function Footer(props) {
	return (
		<>
			<footer className="footer-style">
				<div>
					<div className="footer-content-flex">
						<div>
							<img src={Logo} alt="..." height={60} width={60} />
							<div>
								<p>
									A system developed by the {" "}
									<b>Directorate of Student Affairs (DoSA)</b> of KNUST to help
									students in searching and booking for private hostels &
									homestels around KNUST.
								</p>
							</div>
						</div>
						<div>
							<h5>Quick Links</h5>
							<div className="quick-links">
								<li>
									<Link style={{ color: "#202321" }} to={"/"}>
										Home
									</Link>
								</li>
								<li>
									<Link style={{ color: "#202321" }} to="/hostels">
										Hostels
									</Link>
								</li>
								<li>
									<Link style={{ color: " #202321" }} to={"/homestels"}>
										Homestels
									</Link>
								</li>
								<li>
									<a
										rel="noopener noreferrer"
										style={{ color: " #06863d" }}
										href={`https://obuasicampus.knust.edu.gh/hostels`}
										target="_blank"
									>
										Obuasi Campus
									</a>
								</li>
								<li>
									<Link style={{ color: " #202321" }} to={"/faqs"}>
										FAQs
									</Link>
								</li>
								<li>
									<Link style={{ color: " #202321" }} to={"/help-desk"}>
										Help Desk
									</Link>
								</li>
							</div>
						</div>
						<div>
							<h5>Social Media</h5>
							<div className="social-links">
								<li>
									<a
										rel="noopener noreferrer"
										style={{ color: "#000" }}
										href={`https://twitter.com/DoSA_KNUST`}
										target="_blank"
									>
										<FaFacebook />
									</a>
								</li>
								<li>
									<a
										rel="noopener noreferrer"
										style={{ color: "#000" }}
										href={`https://www.facebook.com/profile.php?id=100084572077515`}
										target="_blank"
									>
										<FaTwitter />
									</a>
								</li>
								<li>
									<a
										rel="noopener noreferrer"
										style={{ color: "#000" }}
										href={`https://twitter.com/DoSA_KNUST`}
										target="_blank"
									>
										<FaInstagram />
									</a>
								</li>
							</div>
						</div>
					</div>
					<div className="mx-5">
						<hr />
					</div>
					<div className="footer-bottom">
						<div className=" footer-text mt-2 text-center">
							Copyright &copy; {new Date().getFullYear()}{" "}
							<b>Directorate of Student Affairs (DoSA)</b>{" "}
						</div>
						<div className=" footer-text mt-2 text-center">
							<b>SuperLax Technologies &reg;</b>{" "}
						</div>
					</div>
				</div>
			</footer>
		</>
	);
}
